export class PurchasingGroupMember {
    constructor(
        public readonly id: string,
        public readonly displayName: string,
        public readonly active: boolean | null,
    ) {}
}
